export default function textBlob() {
  return {
    _id: false,
    type: 'droplet.textBlob',
    tag: 'div',
    text: 'Your text will be here.',
    hasLink: false,
    pageLink: false,
    customLink: false,
    newWindow: false,
    truncate: false,
    truncateLimit: 200,
    mediaQueries: [],
    ref: null,
    siteType: null,
    dynamicKey: null,
    latestDynamic: false,
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-blob/droplet.schema.js